import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AnnuityLetterDialogComponent} from '../annuity-letter-dialog/annuity-letter-dialog.component';

@Component({
  selector: 'app-annuity-confirmation-dialog',
  templateUrl: './annuity-confirmation-dialog.component.html',
  styleUrls: [ './annuity-confirmation-dialog.component.scss' ]
})
export class AnnuityConfirmationDialogComponent implements OnInit {

  public type: string;
  public value: string;
  public installmentValue: string;
  public installmentCount: string;

  constructor (
    public matDialogRef: MatDialogRef<AnnuityLetterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data.gateway === 'cielo') {
      switch (this.data.payload.Payment.Type) {
        case "CreditCard":
          this.type = "Cartão de Crédito"
          break;
        case "Pix":
          this.type = "PIX"
          break;
      }
    } else {

      if (this.data.payload) {
        this.value = this.formatarEmReais(this.data.payload.value);
        this.installmentCount = this.data.payload.installmentCount;
        this.installmentValue = this.data.payload.installmentValue !== "" ? this.formatarEmReais(this.data.payload.installmentValue) : "";

        switch (this.data.payload.billingType) {
          case "CREDIT_CARD":
            this.type = "Cartão de Crédito"
            break;
          case "BOLETO":
            this.type = "Boleto Bancário"
            break;
          case "PIX":
            this.type = "PIX"
            break;
        }
      }
    }

  }

  ngOnInit () {
  }

  formatarEmReais (valor: number): string {
    const formatador = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    // Formata o valor e retorna a string
    return formatador.format(valor);
  }

}
